import { render, staticRenderFns } from "./TemplateOptions.vue?vue&type=template&id=9736c220"
import script from "./TemplateOptions.vue?vue&type=script&lang=js"
export * from "./TemplateOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports